import { useEffect } from "react";
import { useSelector } from "react-redux";
import Router from "next/router";

import GenericSpinner from "@kikoff/components/src/v1/animations/GenericSpinner";

import { PageRegistration } from "@component/flows/hooks/usePageFlow";
import {
  selectAnswer,
  selectEmbeddedAnswer,
  selectFreeformAnswer,
  selectQuestion,
  submitHdyhauResponse,
} from "@feature/hdyhau_survey";
import { track } from "@util/analytics";
import { l10nResources } from "@util/l10n";

import Rows from "./rows";

const l10n = l10nResources({
  en: `continue = Continue
`,
  es: `continue = Continuar
`,
});

interface HdyhauSurveyPageProps extends PageRegistration {
  step:
    | "first-question"
    | "second-question"
    | "freeform-question"
    | "thank-you";
}

function HdyhauSurveyPage({ Button, configFlow }: HdyhauSurveyPageProps) {
  const [question, loadingQuestion] = useSelector(selectQuestion.load());
  const answer = useSelector(selectAnswer());
  const embeddedAnswer = useSelector(selectEmbeddedAnswer());
  const freeformAnswer = useSelector(selectFreeformAnswer());

  configFlow.button(
    <Button
      disabled={!answer || (answer?.nextQuestion && !embeddedAnswer)}
      onClick={async (e) => {
        e.preventDefault();

        track.tap("HDYHAU - Submit Button", {
          option: answer?.key || "not_found",
          suboption: embeddedAnswer?.key || "not_found",
        });

        await submitHdyhauResponse(
          question,
          embeddedAnswer,
          answer,
          freeformAnswer
        );

        setTimeout(() => {
          Router.replace("/dashboard");
        }, 1000);
      }}
    >
      {l10n.getString("continue")}
    </Button>,
    [question, answer, embeddedAnswer, freeformAnswer]
  );

  useEffect(() => {
    track.impression("HDYHAU");
  }, []);

  if (loadingQuestion) return <GenericSpinner />;
  return <Rows />;
}

export default HdyhauSurveyPage;
